class EditorialCarousel {
    constructor({ carouselSelector, groupCells = 2, mobileBreakpoint = 375 }) {
        this.carouselSelector = carouselSelector;
        this.$carousel = document.querySelector(carouselSelector);
        this.$cards = this.$carousel.querySelectorAll(".card");

        this.mobileBreakpoint = mobileBreakpoint;
        this.isDesktop = window.innerWidth > this.mobileBreakpoint;
        this.freeScroll = false;
        this.groupCells = groupCells;
        this.isLast = false;

        // Debounced Functions
        this.debouncedHandleResize = this._debounce(this._handleResize.bind(this), 200);
        this._debouncedHandleSwipeEnd = this._debounce(() => {
            this.isInSession = false;
        }, 200);
    }

    _handleLazyLoad() {
        const $card = document.querySelectorAll(`${this.carouselSelector} .card`);

        // Helper function to load an image in a lazy-picture element
        const loadImage = (picture) => {
            if (!picture || picture.dataset.loaded === "true") return;

            const sources = picture.querySelectorAll("source");
            const img = picture.querySelector("img");

            sources.forEach((source) => {
                source.srcset = source.dataset.srcset;
            });
            img.src = img.dataset.src;

            picture.dataset.loaded = "true";
        };

        // Intersection Observer for all cards
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const cell = entry.target;
                        if (!cell) return;

                        // Load current card
                        const picture = cell.querySelector(".lazy-picture");
                        if (picture) {
                            loadImage(picture);
                        }

                        observer.unobserve(cell);
                    }
                });
            },
            {
                root: this.$carousel,
                threshold: 0.1, // Trigger when 10% of the element is visible
            },
        );

        $card.forEach((cell) => observer.observe(cell));
    }

    _getCarouselConfig() {
        return {
            // Behavior
            groupCells: this.groupCells,
            freeScroll: this.freeScroll,
            selectedAttraction: 0.022,
            friction: 0.37,

            // Cell
            contain: true,
            cellAlign: "left",
            percentPosition: false,

            // UI
            pageDots: false,
        };
    }

    _debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    _handleResize() {
        let isDT = window.innerWidth > this.mobileBreakpoint;
        if (isDT !== this.isDesktop) {
            console.log("change perspective");
            this.isDesktop = window.innerWidth > this.mobileBreakpoint;
            this.destroy();
            this.init();
        }
    }

    _handleWheelEvent(e) {
        if (Math.abs(e.deltaX) > 0) {
            e.preventDefault();
        }

        this._debouncedHandleSwipeEnd();

        if (Math.abs(e.deltaY) > 0) {
            return;
        }

        if (!this.isInSession) {
            if (e.deltaX > 1) {
                this.isInSession = true;
                this.flickityInstance.next();
            }
            if (e.deltaX < -1) {
                this.isInSession = true;
                this.flickityInstance.previous();
            }
        }
    }

    _setupEventListeners() {
        // Handle Resize
        window.addEventListener("resize", this.debouncedHandleResize);
        if (!this.isDesktop) {
            this.flickityInstance.on("select", (index) => {
                if (index === this.$cards.length - 1) {
                    this.isLast = true;
                    this.$carousel.classList.add("add-space");
                } else if (this.isLast) {
                    this.$carousel.classList.remove("add-space");
                    this.isLast = false;
                }
            });
        }

        // Handle Swipe
        this.$carousel.addEventListener("wheel", this._handleWheelEvent.bind(this), { passive: false });
    }

    _initCarousel() {
        this.freeScroll = this.isDesktop ? false : true;
        this.groupCells = this.isDesktop ? this.groupCells : false;

        this.flickityInstance = new Flickity(this.$carousel, this._getCarouselConfig());
        this._handleLazyLoad();
    }

    destroy() {
        if (this.flickityInstance) {
            this.flickityInstance.destroy();
            this.flickityInstance = null;
        }
    }

    init() {
        this._initCarousel();
        this._setupEventListeners();
        return this;
    }
}

module.exports = EditorialCarousel;
